'use strict'; //

exports.__esModule = true;
exports.default = void 0;

require("./lang.less");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _enhance = _interopRequireDefault(require("../core/enhance"));

var _component = _interopRequireDefault(require("../core/component"));

var _tools = _interopRequireDefault(require("../libs/tools"));

var _language = _interopRequireDefault(require("../libs/language"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 *语言包
 */
var Lang = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Lang, _Component);

  function Lang(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      lang: ''
    };

    _this.handlerLanguageChange = function () {
      _this.forceUpdate();
    };

    return _this;
  }
  /**
   * componentDidMount()在挂载结束之后马上被调用。需要DOM节点的初始化操作应该放在这里。
   */


  var _proto = Lang.prototype;

  _proto.componentDidMount = function componentDidMount() {
    //添加监听
    this._on('Language', this.handlerLanguageChange);
  }
  /**
   * 在组件从 DOM 中移除的时候立刻被调用。
   */
  ;

  _proto.componentWillUnmount = function componentWillUnmount() {
    //移除监听
    this._un('Language', this.handlerLanguageChange);
  }
  /**
   *
   * @return {*}
   */
  ;

  _proto.render = function render() {
    if (this.props.lang === ' ') {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)('c-lang', this.props.className),
        style: this.props.style,
        "data-lang": this.props.lang
      }, "\xA0");
    }

    if (_tools.default.is_string(this.props.lang)) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: (0, _classnames.default)('c-lang', this.props.className),
        style: this.props.style,
        "data-lang": this.props.lang
      }, _language.default.get(this.props.lang) || (window.lang || {})[this.props.lang] || this.props.lang);
    } else {
      return null;
    }
  }
  /**
   *
   * @private
   */
  ;

  return Lang;
}(_component.default);

(0, _enhance.default)(Lang, {}, 'Lang');
var _default = Lang;
exports.default = _default;
module.exports = exports.default;